import {useEffect, useState} from 'react'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {subscribe, unsubscribe} from '@/script/event.mjs'

const getItems = map => {
    const next = (chain) => {
        const n = map.nodeProxy(chain[0])
        const isOutdated = Boolean(n.isOutdated?.())
        const isHidden = map.isNodeHidden(chain[0])

        return {
            yieldChildren: ! isHidden,
            yieldNode: isOutdated && ! isHidden,
        }
    }

    return [...map.dfs(map.root.children, next)]
}

export default () => {
    const map = useMapContext()
    const [items, setItems] = useState(() => getItems(map))

    useEffect(
        () => {
            const handleModelChange = () => {
                map.logger.withOff(
                    () => setItems(getItems(map))
                )
            }

            subscribe(map, 'model_change', handleModelChange)

            return () => {
                unsubscribe(map, 'model_change', handleModelChange)
            }
        },

        []
    )

    return items
}
